import { render, staticRenderFns } from "./InstagramHome.vue?vue&type=template&id=980dbbaa&"
import script from "./InstagramHome.vue?vue&type=script&lang=js&"
export * from "./InstagramHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports